module.exports = __webpack_public_path__ + "img/image05_sp.60603da2.jpg";